import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Step } from 'semantic-ui-react';

const WizardStepTitle = ({ entity, index, steps }) => (
  <Step.Title className="aridhia-wizard-step-title">
    <FormattedMessage id={`${entity}.breadcrumb.${steps[index]}_title`} />
  </Step.Title>
);

export default WizardStepTitle;
